import { useEffect } from "react";
import { useMap } from "react-leaflet";

type InvalidateMapSizeProps = {
  sizeTrigger: unknown;
};

const RECALCULATE_SIZE_DELAY_MS = 200;

export function InvalidateMapSize({ sizeTrigger }: InvalidateMapSizeProps) {
  const map = useMap();
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      map.invalidateSize();
    });
    const t = setTimeout(() => {
      map.invalidateSize();
    }, RECALCULATE_SIZE_DELAY_MS);
    return () => {
      cancelAnimationFrame(id);
      clearTimeout(t);
    };
  }, [map, sizeTrigger]);
  return null;
}
